import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileCompanyCamProjects = {
  index: async(props) => {
    const { default: ProjectsIndex } = await import('@/vue_widgets/geobooster/company_cam/projects/index.vue')
    createVueApp(ProjectsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: ProjectShow } = await import('@/vue_widgets/geobooster/company_cam/projects/show/index.vue')
    createVueApp(ProjectShow, { props, sidebar })
  }
}
